import { IsString, MaxLength } from 'class-validator';

export class IssueApiKeyDto {
  @IsString()
  @MaxLength(60)
  label!: string; // e.g. "production", "staging"
}
